export const protoFileRegexPattern = "(proto)";
export const protoFilesInsideFolderPattern = "^(.+)/([^/]+)$";

export const validateCompressedFiles = (regexPattern, entry, isRestrict = false) => {
    const isExpectedFile = Object.values(entry.files).some((file) => {
        return file.name.match(regexPattern);
    });
    let isNotExpectedFiles = false;

    if (isRestrict && isExpectedFile) {
        isNotExpectedFiles = Object.values(entry.files).some((file) => {
            return !file.name.match(regexPattern);
        });
    }

    return isExpectedFile && !isNotExpectedFiles;
};

export const isIndexFileInsideFolder = (entry) => {
    const isExpectedFile = Object.values(entry.files).some((file) => {
        return file.name.indexOf("/index.js") !== -1;
    });

    return isExpectedFile;
};

const isFileProto = (file) => (file.name.match(protoFileRegexPattern) ? 1 : 0);

export const protoFilesCounter = (entry) => {
    const initialValue = 0;

    const countProtoFiles = Object.values(entry.files).reduce(
        (accumulator, file) => accumulator + isFileProto(file),
        initialValue
    );
    return countProtoFiles;
};
